import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"beer"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M6.5 22H15.5C16.1828 22 16.5 21.674 16.5 21V19V9H7.5V13C7.5 14.1046 6.60457 15 5.5 15V21C5.5 21.674 5.81718 22 6.5 22Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M16.5 9C17.5 9 17.5 7 17.5 6.5C17.5 5.11929 16.3807 4 15 4C14.6689 4 13.5 4 13.5 4C13 3 11.5542 2 10 2C8.02829 2 6.5 3.5 6.5 5C6.5 5 5.88948 5 5.5 5C4.39543 5 3.5 5.89543 3.5 7V13C3.5 14.1046 4.39543 15 5.5 15C6.60457 15 7.5 14.1046 7.5 13V9H16.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5.5 15V21C5.5 21.674 5.81718 22 6.5 22H15.5C16.1828 22 16.5 21.674 16.5 21V19M5.5 15C6.60457 15 7.5 14.1046 7.5 13V9H16.5M5.5 15C4.39543 15 3.5 14.1046 3.5 13V7C3.5 5.89543 4.39543 5 5.5 5C5.88948 5 6.5 5 6.5 5C6.5 3.5 8.02829 2 10 2C11.5542 2 13 3 13.5 4C13.5 4 14.6689 4 15 4C16.3807 4 17.5 5.11929 17.5 6.5C17.5 7 17.5 9 16.5 9M16.5 9V19M16.5 9H19.5C20.1828 9 20.5 9.34297 20.5 10.0169V18C20.5 18.674 20.1828 19 19.5 19H16.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Beer = Vue.extend<IconProps>({
  name: 'BeerIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'beer',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Beer;
